import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { afterItems, beforeItems } from '../data/content';
export function BeforeAfter() {
  return <section className="bg-cream px-4 py-16 sm:py-24" aria-labelledby="before-after-title" data-id="element-50" data-mp="3oi42p7vgbped">
      <div className="mx-auto max-w-5xl" data-id="element-51" data-mp="3sjfu9ixvykp7">
        <div id="before-after-title" data-id="element-52" data-mp="3epga6pbi87lg">
          <SectionHeading title={<>
                From saving techniques <em className="text-brand-700" data-id="element-54" data-mp="3ji9bt4boeztb">to actually using them</em>
              </>} data-id="element-53" data-mp="3eode82zbreyo" />
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-55" data-mp="34ppeikb7jmjs">
          <div className="rounded-3xl border border-danger/20 bg-[#FCEEEC] p-6 sm:p-8" data-id="element-56" data-mp="39rwqvazy94mn">
            <h3 className="flex items-center gap-2 text-lg font-extrabold uppercase tracking-wide text-danger" data-id="element-57" data-mp="2vqu8b885ycgh">
              <XCircleIcon className="h-6 w-6" aria-hidden="true" data-id="element-58" data-mp="30ovo9kaalvnq" />
              Before
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-59" data-mp="x392p89xd4je">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-ink/80" data-id="element-60" data-mp="t1x9ytvr836z">
                  <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-61" data-mp="171oqp2dnnxoo" />
                  <span data-id="element-62" data-mp="124omyy4a370q">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-brand-800 p-6 text-white shadow-xl shadow-brand-900/20 sm:p-8" data-id="element-63" data-mp="eeu9qfg1rgfy">
            <h3 className="flex flex-wrap items-center gap-x-2 gap-y-1 text-lg font-extrabold uppercase tracking-wide text-gold-light" data-id="element-64" data-mp="9gaji2uf7ihs">
              <CheckCircle2Icon className="h-6 w-6" aria-hidden="true" data-id="element-65" data-mp="o5oyprkogu53" />
              After
              <span className="text-xs font-semibold normal-case tracking-normal text-brand-100" data-id="element-66" data-mp="jb2mxnaoozkh">
                with the Apometry Practice Deck™
              </span>
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-67" data-mp="3mtm3vtnwwizz">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[16px] font-medium leading-snug" data-id="element-68" data-mp="1qq7vffxqj5we">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-69" data-mp="1voj3pm8dt8ci" />
                  <span data-id="element-70" data-mp="20h2kes2d8jlj">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <SectionCta label="I want to leave improvising behind" data-id="element-71" data-mp="24k8n5pq9rsn9" />
      </div>
    </section>;
}